// extracted by mini-css-extract-plugin
export default {"timelineItem":"ut33rd3xu4g3ObPGEBI1","svg":"WthxBLF_dL46tXs8yDYS","bounce":"uYo9FmOWFQ8yv7kJfFa4","timelineItemWrap":"sQ8pVIAWFsRcXg2uEGnv","active":"tCBZCNL22859Y0uIHeri"};